"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import a from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.957 15.094a3.5 3.5 0 0 0 4.95 4.95l3.712-3.713a3.5 3.5 0 0 0 0-4.95.625.625 0 1 1 .884-.884 4.75 4.75 0 0 1 0 6.718L9.79 20.927a4.75 4.75 0 1 1-6.717-6.717l3.447-3.447a.625.625 0 1 1 .884.883zm6.452-1.503a4.75 4.75 0 0 1 0-6.718l3.8-3.8a4.75 4.75 0 1 1 6.718 6.717l-3.447 3.448a.625.625 0 0 1-.884-.884l3.447-3.448a3.5 3.5 0 1 0-4.95-4.95l-3.8 3.801a3.5 3.5 0 0 0 0 4.95.625.625 0 1 1-.884.884",
        clipRule: "evenodd"
      }
    )
  }
), n = e(t);
export {
  n as Copy,
  n as default
};
